


















































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  PolyDialogTypeInterface,
  TimeTableItemUpdateInterface,
  MealInterface
} from "@/interfaces/index.ts";

@Component({})
export default class PolyDialog extends Vue {
  @Prop() private dialogType!: PolyDialogTypeInterface;

  toast: boolean = false;
  toastMessage: string = "";

  timetableItemSelected: boolean = false;
  timetableItemValue: string = "";
  originalTimeTableItemValue: string = "";

  timetableItemNotesSelected: boolean = false;
  timetableItemNotesValue: string = "";
  originalTimeTableItemNotesValue: string = "";

  timetableItemParentDate: number | undefined;
  timetableItemIndex: number | undefined;

  timetableSelected: boolean = false;

  addRemoveWeekInfoSelected: boolean = false;

  addWeekSelected: boolean = false;
  addWeekNumber: number = 0;

  removeWeekSelected: boolean = false;
  removeWeekNumber: number = 0;

  editTimetableItemSelected: boolean = false;
  editTimetableItem: TimeTableItemUpdateInterface | undefined;
  editTimeTableItemValue: string = "";
  editTimeTableItemNotes: string = "";

  signupLoginSelected: boolean = false;
  signupSelected: boolean = false;
  loginSelected: boolean = false;
  email: string = "";
  password: string = "";
  confirmPassword: string = "";

  timetableName: string = "";
  addTimetableNameSelected: boolean = false;

  timetableNameToChange: string = "";
  changeTimetableNameSelected: boolean = false;

  isConfirmSelected: boolean = false;
  isDeleteTimetableSelected: boolean = false;
  logoutSelected: boolean = false;
  deleteTimetableId: string = "";
  clearHistory: boolean = false;
  clearAllData: boolean = false;
  deleteMyAccount: boolean = false;

  isLoadingSelected: boolean = false;

  deleteHistoryItem: boolean = false;
  historyItemIndex: number | undefined;

  confirmationText: string = "";
  cancelText: string = "Cancel";

  pageEvent: string | undefined;

  mounted() {
    this.getDialogType();
    this.setDialogActionTexts();
  }

  getSharedDialogTypes(data: PolyDialogTypeInterface): void {
    this.addWeekSelected = data.addWeekSelected === true;
    if (this.addWeekSelected) this.addWeekNumber = data.addWeekNumber as number;

    this.removeWeekSelected = data.removeWeekSelected === true;
    if (this.removeWeekSelected)
      this.removeWeekNumber = data.removeWeekNumber as number;

    this.addRemoveWeekInfoSelected =
      this.addWeekSelected || this.removeWeekSelected;

    this.signupSelected = data.signupSelected === true;
    this.loginSelected = data.loginSelected === true;
    this.signupLoginSelected = this.signupSelected || this.loginSelected;

    this.addTimetableNameSelected = data.addTimetableNameSelected === true;

    this.changeTimetableNameSelected =
      data.changeTimetableNameSelected === true;
    if (this.changeTimetableNameSelected) {
      this.timetableNameToChange = data.timetableNameToChange as string;
      this.timetableName = data.timetableNameToChange as string;
    }
  }

  getUniqueDialogTypes(data: PolyDialogTypeInterface): void {
    this.timetableItemSelected = data.timetableItemSelected === true;
    this.timetableItemNotesSelected = data.timetableItemNotesSelected === true;

    this.timetableSelected = data.timetableSelected === true;

    this.editTimetableItemSelected = data.editTimetableItemSelected === true;

    this.isConfirmSelected = data.isConfirmSelected === true;
    if (this.isConfirmSelected) {
      this.isDeleteTimetableSelected = data.isDeleteTimetableSelected === true;
      this.deleteTimetableId = data.deleteTimetableId as string;
      this.logoutSelected = data.logoutSelected as boolean;
      this.clearHistory = data.clearHistory as boolean;
      this.clearAllData = data.clearAllData as boolean;
      this.deleteMyAccount = data.deleteMyAccount as boolean;

      this.deleteHistoryItem = data.deleteHistoryItem || false;
      if (this.deleteHistoryItem) this.historyItemIndex = data.historyItemIndex;
    }

    this.isLoadingSelected = data.isLoadingSelected === true;

    if (this.timetableItemSelected) {
      this.timetableItemValue = data.timetableItemValue as any;
      this.originalTimeTableItemValue = data.timetableItemValue as any;
      this.timetableItemParentDate = data.timetableItemParentDate;
      this.timetableItemIndex = data.timetableItemIndex;
    }

    if (this.timetableItemNotesSelected) {
      this.timetableItemNotesValue = data.timetableItemNotesValue || "";
      this.originalTimeTableItemNotesValue = data.timetableItemNotesValue || "";

      this.timetableItemParentDate = data.timetableItemParentDate;
      this.timetableItemIndex = data.timetableItemIndex;
    }

    if (this.editTimetableItemSelected) {
      this.editTimetableItem = data.editTimetableItem;
      this.editTimeTableItemValue = this.editTimetableItem!.item
        .value as string;
      this.editTimeTableItemNotes = this.editTimetableItem!.item
        .notes as string;
    }
  }

  getDialogType(): void {
    const data: PolyDialogTypeInterface = this.dialogType;
    if (!data) return;

    this.pageEvent = data.pageEvent;

    this.getSharedDialogTypes(data);
    this.getUniqueDialogTypes(data);

    this.setDialogActionTexts();
  }

  setDialogActionTexts(): void {
    this.cancelText = this.isConfirmSelected ? "No" : "Cancel";

    this.confirmationText =
      this.timetableItemSelected ||
      this.timetableItemNotesSelected ||
      this.changeTimetableNameSelected
        ? "Update"
        : this.addWeekSelected
        ? "Add"
        : this.removeWeekSelected
        ? "Remove"
        : this.editTimetableItemSelected ||
          this.timetableSelected ||
          this.addTimetableNameSelected
        ? "Save"
        : this.signupLoginSelected
        ? "Ok"
        : this.isConfirmSelected
        ? "Yes"
        : "";
  }

  showToast(message: string): void {
    const simpleMessage = message.toLowerCase();

    if (
      simpleMessage.includes("typeerror") ||
      simpleMessage.includes("network")
    )
      return;
    else if (
      simpleMessage.includes("html") ||
      simpleMessage.includes("undefined")
    )
      message = "Please try again later";

    this.toastMessage = message;
    this.toast = true;
  }

  handleTimeTableItemClicked(): void {
    // CHECK 1
    // If timetable item is unchanged
    if (
      this.originalTimeTableItemValue &&
      this.originalTimeTableItemValue.trim().length > 0 &&
      this.timetableItemValue === this.originalTimeTableItemValue
    ) {
      this.showToast("You haven't changed a thing!");
      return;
    }

    // CHECK 2
    // If no value is filled
    if (!this.timetableItemValue.trim()) {
      this.showToast("Please fill it in so we can store it");
      return;
    }

    this.closeDialogWithValue({
      timetableItemSelected: this.timetableItemSelected,
      timetableItemParentDate: this.timetableItemParentDate,
      timetableItemIndex: this.timetableItemIndex,
      updateValue: this.timetableItemValue
    });
  }

  handleTimeTableItemNotesClicked(): void {
    // CHECK 1
    // If timetable item is unchanged
    if (
      this.originalTimeTableItemNotesValue.trim().length > 0 &&
      this.timetableItemNotesValue === this.originalTimeTableItemNotesValue
    ) {
      this.showToast("You haven't changed a thing!");
      return;
    }

    this.closeDialogWithValue({
      timetableItemNotesSelected: this.timetableItemNotesSelected,
      timetableItemParentDate: this.timetableItemParentDate,
      timetableItemIndex: this.timetableItemIndex,
      updateValue: this.timetableItemNotesValue
    });
  }

  handleDeleteHistoryItemClicked(): void {
    // If its reached here, then that's a confirmation
    this.closeDialogWithValue({
      isConfirmSelected: this.isConfirmSelected,
      deleteHistoryItem: true,
      historyItemIndex: this.historyItemIndex
    });
  }

  handleEditTimeTableItemClicked(): void {
    const item: MealInterface = this.editTimetableItem!.item;

    const valuesAreNull = !this.editTimeTableItemValue;
    const valuesAreSame =
      this.editTimeTableItemValue &&
      this.editTimeTableItemValue === item.value &&
      this.editTimeTableItemNotes === item.notes;

    if (valuesAreNull) {
      this.showToast(`What would you like to have for ${item.title}?`);
      return;
    }

    if (valuesAreSame) {
      this.showToast("You haven't changed a thing!");
      return;
    }

    this.editTimetableItem!.item.value = this.editTimeTableItemValue;
    this.editTimetableItem!.item.notes = this.editTimeTableItemNotes;

    this.closeDialogWithValue({
      editTimetableItemSelected: this.editTimetableItemSelected,
      // Is the updatedTimetable item
      editTimetableItem: this.editTimetableItem
    });
  }

  handleAddRemoveWeekInfoClicked(): void {
    this.closeDialogWithValue({
      addWeekSelected: this.addWeekSelected,
      removeWeekSelected: this.removeWeekSelected
    });
  }

  handleTimetableNameClicked(): void {
    const valuesAreNull =
      !this.timetableName ||
      (this.timetableName && this.timetableName.trim().length === 0);
    const valuesAreSame =
      this.changeTimetableNameSelected &&
      this.timetableName &&
      this.timetableName.toLowerCase() ===
        this.timetableNameToChange.toLocaleLowerCase();

    if (valuesAreNull) {
      this.showToast(`Please pick a name for your timetable`);
      return;
    }

    if (valuesAreSame) {
      this.showToast("The timetable names are the same");
      return;
    }

    this.closeDialogWithValue({
      addTimetableNameSelected: this.addTimetableNameSelected,
      changeTimetableNameSelected: this.changeTimetableNameSelected,
      timetableNameToChange: this.timetableNameToChange,
      updateValue: this.timetableName
    });
  }

  handleDeleteTimetableItemClicked(): void {
    this.closeDialogWithValue({
      isConfirmSelected: this.isConfirmSelected,
      isDeleteTimetableSelected: this.isDeleteTimetableSelected,
      deleteTimetableId: this.deleteTimetableId
    });
  }

  handleSignupClicked(): void {
    const emailIsNotFilled =
      !this.email || (this.email && this.email.trim().length === 0);

    const passwordNotFilledIn =
      !this.password || (this.password && this.password.trim().length === 0);
    const passwordTooShort = this.password && this.password.length < 6;
    const passwordsDontMatch = this.confirmPassword !== this.password;

    const message = emailIsNotFilled
      ? "Please fill in your email"
      : passwordNotFilledIn
      ? "Please fill in your password"
      : passwordTooShort
      ? "Your password should be above 6 characters"
      : passwordsDontMatch
      ? "Your passwords don't match"
      : null;

    if (message) {
      this.showToast(message);
      return;
    }

    this.closeDialogWithValue({
      signupSelected: true,
      email: this.email.toLowerCase(),
      password: this.password
    });
  }

  handleLoginSelected(): void {
    const emailIsNotFilled =
      !this.email || (this.email && this.email.trim().length === 0);

    const passwordNotFilledIn =
      !this.password || (this.password && this.password.trim().length === 0);
    const passwordTooShort = this.password && this.password.length < 6;

    const message = emailIsNotFilled
      ? "Please fill in your email"
      : passwordNotFilledIn
      ? "Please fill in your password"
      : passwordTooShort
      ? "Your password should be above 6 characters"
      : null;

    if (message) {
      this.showToast(message);
      return;
    }

    this.closeDialogWithValue({
      loginSelected: true,
      email: this.email.toLowerCase(),
      password: this.password
    });
  }

  handleClearHistoryClicked(): void {
    this.closeDialogWithValue({
      isConfirmSelected: true,
      clearHistory: this.clearHistory
    });
  }

  handleClearAllDataClicked(): void {
    this.closeDialogWithValue({
      isConfirmSelected: true,
      clearAllData: this.clearAllData
    });
  }

  handleDeleteMyAccountClicked(): void {
    this.closeDialogWithValue({
      isConfirmSelected: true,
      deleteMyAccount: this.deleteMyAccount
    });
  }

  handleLogoutClicked(): void {
    this.closeDialogWithValue({
      isConfirmSelected: true,
      logoutSelected: this.logoutSelected
    });
  }

  confirm(): void {
    // Timetable item
    if (this.timetableItemSelected) this.handleTimeTableItemClicked();

    if (this.timetableItemNotesSelected) this.handleTimeTableItemNotesClicked();

    if (this.editTimetableItemSelected) this.handleEditTimeTableItemClicked();

    if (this.addRemoveWeekInfoSelected) this.handleAddRemoveWeekInfoClicked();

    if (this.addTimetableNameSelected || this.changeTimetableNameSelected)
      this.handleTimetableNameClicked();

    if (this.signupSelected) this.handleSignupClicked();

    if (this.loginSelected) this.handleLoginSelected();

    if (this.isConfirmSelected)
      if (this.deleteHistoryItem) this.handleDeleteHistoryItemClicked();
      else if (this.isDeleteTimetableSelected)
        this.handleDeleteTimetableItemClicked();
      else if (this.clearHistory) this.handleClearHistoryClicked();
      else if (this.clearAllData) this.handleClearAllDataClicked();
      else if (this.logoutSelected) this.handleLogoutClicked();
      else if (this.deleteMyAccount) this.handleDeleteMyAccountClicked();
  }

  forgotMyPassword(email: string): void {
    const emailIsNotFilled = !this.email || this.email!.trim().length === 0;

    if (emailIsNotFilled) {
      this.showToast("What's your email account?");
      return;
    }

    this.closeDialogWithValue({
      forgotPasswordSelected: true,
      email: this.email
    });
  }

  selectTimetable(): void {
    this.closeDialogWithValue({
      selectTimetable: true,
      timetableNameToChange: this.timetableNameToChange
    });
  }

  closeDialogWithValue(value: PolyDialogTypeInterface): void {
    value.pageEvent = this.pageEvent;

    this.$emit("dismissDialogWithData", value);
  }

  dismissDialog(): void {
    this.$emit("dismissDialog");
  }
}
